import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router";
import {CreditNoteListCreditNotes} from "./CreditNoteListCreditNotes";

export default function CreditNoteList(props) {
    const [data, setData] = useState({creditNotes: [], loading: true});

    const navigate = useNavigate()

    useEffect(() => {
        document.title = 'Credit notes'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
        fetchData()
    }, [])

    const fetchData = async () => {
        var url = API_URL + '/api/private/tanker/v1/credit-notes'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                setData({creditNotes: data, loading: false});
            });
    }

    return (
        <div>
            <CreditNoteListCreditNotes creditNotes={data.creditNotes}/>
        </div>
    )
}


